import {LayoutContent, LayoutHeader, LayoutTopbar} from '@tinct/web-layout';
import {HubspotIntegration} from "../../components/hubspot-integration";
import {AttioIntegration} from "../../components/attio-integration";
import {SalesforceIntegration} from "../../components/salesforce-integration";
import {RudderstackIntegration} from "../../components/rudderstack-integration";
import {GoogleAdsIntegration} from "../../components/google-ads-integration";
import {LinkedinAdsIntegration} from "../../components/linkedin-ads-integration";

export function EditIntegrationsPage() {



  return (
    <div>
      <header className="sticky top-0 z-30">
        <LayoutTopbar />
      </header>
      <LayoutContent>
        <LayoutHeader
          pageTitle="Integration"
          pageDescription="Connect your tools"
        />

        <div className="flex flex-col gap-8">
          <div className="flex flex-row gap-4">
            <HubspotIntegration />
            <AttioIntegration />
            <SalesforceIntegration />
            <RudderstackIntegration />
            <GoogleAdsIntegration />
            <LinkedinAdsIntegration />
          </div>
        </div>
      </LayoutContent>

    </div>
  );
}
